import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {getCall, getById, postCall} from "../../utils/api";
import {startLoading, stopLoading} from "../loading";

const initialState = {
    data: [],
    offerDetail: null,
    error: "",
    status: "idle",
    isUpdateStatus: "idle",
};

export const getCrawlOffers = createAsyncThunk(
    "CrawlOffer/get",
    async ({ from_id = 1, page = 1, exclude_expired = 1 }) => {
        try {
            return await getCall(
                `/admin/v1/all_offer_ref?from=${from_id}&page=${page}&exclude_expired=${exclude_expired}`,
                false
            );
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const getCrawlOfferById = createAsyncThunk(
    "CrawlOffer/getById",
    async (id, {dispatch}) => {
        dispatch(startLoading());
        try {
            return await getById("/admin/v1/show_offer_ref", id, false);
        } catch (error) {
            return Promise?.reject(error);
        } finally {
            dispatch(stopLoading());
        }
    }
);

export const assignCrawlOffer = createAsyncThunk(
    "CrawlOffer/assign",
    async ({ outlet_ref_id, outlet_ids }) => {
        try {
            return await postCall(`/admin/v1/outlet_ref/assign`, {
                outlet_ref_id,
                outlet_ids,
            }, true);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const updateCrawlOffer = createAsyncThunk(
    "CrawlOffer/update",
    async ({ id, formData }) => {
        try {
            return await postCall(`/admin/v1/update_offer_ref/${id}`, formData, false);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

const CrawlOfferSlice = createSlice({
    name: "crawlOutlet",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCrawlOffers.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getCrawlOffers.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(getCrawlOffers.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(getCrawlOfferById.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getCrawlOfferById.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(getCrawlOfferById.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.offerDetail = action.payload;
            })
            .addCase(assignCrawlOffer.pending, (state) => {
                state.isUpdateStatus = "loading";
                state.error = null;
            })
            .addCase(assignCrawlOffer.fulfilled, (state, action) => {
                state.isUpdateStatus = "succeeded";
            })
            .addCase(assignCrawlOffer.rejected, (state, action) => {
                state.isUpdateStatus = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(updateCrawlOffer.pending, (state) => {
                state.isUpdateStatus = "loading";
                state.error = null;
            })
            .addCase(updateCrawlOffer.fulfilled, (state, action) => {
                state.isUpdateStatus = "succeeded";
                const index = state?.data?.data?.findIndex(
                    (offer) => offer.id === action.payload.data.id
                );
                if (index >= 0) {
                    state.data.data[index] = action.payload.data;
                }
            })
            .addCase(updateCrawlOffer.rejected, (state, action) => {
                state.isUpdateStatus = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
    },
});

export default CrawlOfferSlice.reducer;
